import { render, staticRenderFns } from "./OtherDetails.vue?vue&type=template&id=d71497cc&"
import script from "./OtherDetails.vue?vue&type=script&lang=js&"
export * from "./OtherDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports